import { Box } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import Table from '../../TableResizable';
import DataPeriodMVirement from "../../../Functions/Traitement/DataPeriodMVirement";

const Tab6 = (props: { form?: any, DataPeriodAuto: DataPeriodMVirement[] }) => {

 // DECLARATION DES COLONNES DU TABLEAU
const columns: ColumnsType<DataPeriodMVirement> = [
    {
        title: 'Numero Dossier',
        dataIndex: 'NUMDOS',
        ellipsis: true,
        width: 80,
    },
    {
        title: 'Compte débit',
        dataIndex: 'CPTDEB',
        ellipsis: true,
        width: 80,
    },
    {
        title: 'Compte crédit',
        dataIndex: 'CPTCRE',
        ellipsis: true,
        width:80 ,
    },
    {
        title: 'Montant',
        dataIndex: 'MONTAN',
        ellipsis: true,
        width: 80,
        align:"right"
    },
    {
        title: 'Status',
        dataIndex: 'cdetat',
        ellipsis: true,
        width: 50,
    },
    {
        title: 'Saisie par',
        dataIndex: 'UTISAI',
        ellipsis: true,
        width: 50,
    },
    {
        title: 'Agence',
        dataIndex: 'codage',
        ellipsis: true,
        width: 50,
    }
    //STACHQ
];


    return (
        <div className='tabItem'>
            <div >
                <Box display={'flex'} fontStyle="inherit" width={"85%"} position={"absolute"} >
                    <Box fontStyle="inherit" className='bordure1' >
                        <legend>Virements permenants </legend>
                        <Table pagination={false} size='small' dataSource={props.DataPeriodAuto} columns={columns} style={{ width: '100%' }} scroll={{ y: 350,x: 1300 }} />
                    </Box>
                </Box>
            </div>
        </div>

    );

}

export default Tab6;